import { TableCellProps } from '@servicetitan/design-system';
import { FC } from 'react';

export const customCell =
  <T = any,>(
    Component: FC<Omit<TableCellProps, 'dataItem'> & { dataItem: T }>,
  ): FC<TableCellProps> =>
  (props) => {
    return props.rowType === 'data' ? (
      <td
        className={props.className}
        colSpan={props.colSpan}
        style={props.style}
        aria-colindex={props.ariaColumnIndex}
        aria-selected={props.isSelected}
      >
        <Component {...props} />
      </td>
    ) : null;
  };
